import React, { useEffect } from 'react';
import { View, AppState, Platform } from 'react-native';

import _ from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';

import OverlayContent from './OverlayContent';
import styles from './styles';

function OverlayScreen({ visible, animationType = 'slide', onFocus, ...props }) {
  useEffect(() => {
    const canAddFocusListener = onFocus && Platform.OS === 'android';
    const focusListener = canAddFocusListener && AppState.addEventListener('focus', onFocus);

    return () => {
      if (canAddFocusListener) {
        if (_.isFunction(focusListener?.remove)) {
          focusListener.remove();
        } else {
          // RNSUPPORT: keeps RN 0.64.2 supported
          AppState.removeEventListener('focus', onFocus);
        }
      }
    };
  }, [onFocus]);

  return visible ? (
    <View
      animationType={animationType}
      transparent={false}
      coverScreen={false}
      style={styles.outerContainer}
      testID={FoundationTestKeys.overlayScreenView}
    >
      <OverlayContent {...props} />
    </View>
  ) : null;
}

OverlayScreen.propTypes = {
  visible: PropTypes.bool,
  centerImage: PropTypes.shape({ uri: PropTypes.string.isRequired }),
  closeIcon: PropTypes.shape({ uri: PropTypes.string.isRequired }),
  headerKey: PropTypes.string,
  descriptionKey: PropTypes.string,
  onProceed: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  animationType: PropTypes.string,
  onFocus: PropTypes.func,
  hasSingleButton: PropTypes.bool,
  okButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  allowFontScaling: PropTypes.bool,
};

export default OverlayScreen;
